const btnManagementService = {
  label: 'filtros',
  Typography: 'Nenhum resultado encontrado'
};

export default btnManagementService;
